export default "__VITE_ASSET__3cdedc93__"